<template>
    <div :class="['case-list', sMove == 'top' ? 'show-all':'', sMove == 'bottom' ? 'show-half':'']">
        <div class="close">
            <!-- <button @click="goTop()">上去</button> -->
            <img src="@/assets/images/case/line.png" @click="goTop()" v-if="sMove == 'bottom' || !sMove" alt="" class="top">
            <img src="@/assets/images/case/line.png" @click="goBottom()" v-if="sMove == 'top'" alt="" class="bottom">
        </div>
        <pull-to
            :is-top-bounce="false"
            @infinite-scroll="upRefresh"
            :top-config="TOP_DEFAULT_CONFIG"
            :is-bottom-bounce="false"
            bottom-block-height:0
            top-block-height:0
        >
            <ul class="list" v-if="arrCaseList.length !== 0">
                <li v-for="(item, index) in arrCaseList" :key="item.id" @click.stop="toCaseDetail(item.id, item.is_new)">
                    <img v-lazy="cover(item)" alt="" />
                    <div class="list-right">
                        <p class="title">{{item.city_name}}-{{item.address}}{{item.house_area ? item.house_area + 'm²':''}}户型安装案例</p>
                        <!-- <p class="info">{{item.house_style}},{{item.house_area}}m²</p> -->
                        <div class="shop-list">
                            <span class="shop" v-for="(item, index) in  textFormat(item.scence)" :key="index">{{item.type_name}}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="no-data" v-else>暂无更多案例</div>
        </pull-to>
    </div>
</template>

<script>
import path from "@/path.js";
import PullTo from "vue-pull-to";
export default {
    name: 'caseMap',
    components:{
        PullTo,
    },
    data() {
        return {
            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },

            sMove:''
        }
    },
    props: {
        arrCaseList:{
            type:Array,
            default:[]
        }
    },
    filters:{

    },
    created() {

    },
    mounted(){

    },
    computed:{

    },
    watch:{

    },
    methods:{
        cover(item) {
            // console.log(item)
            if (item.cover && item.is_new == 1) {
                return item.cover
            } else {
                return item.scence.length && item.scence[0].house_img.length ? item.scence[0].house_img[0].img_url : ''
            }

        },
        textFormat(value) {
            if (value.length !== 0) {
                let arr = []
                value.forEach(item => {
                    item.device_info.forEach(itemChild => {
                        arr.push(itemChild)
                    })
                })
                return arr
            } else {
                return []
            }
        },
        //下拉
        // downRefresh(loaded) {
        //     // this.page = 0;
        //     // this.bhow = false;
        //     // this.caseList = [];
        //     // this.getCaselist();
        //     // loaded("done");
        // },

        //上拉
        upRefresh(loaded) {
            // let page = this.page + 1;
            // this.page = page;
            // this.getCaselist(page);
            // this.loading = true;
            // console.log("2");
            // loaded("done");
            // console.log(123456)
        },

        closeCaseList() {
            this.$emit('close-case-list')
        },

        toCaseDetail(id, isNew) {
            if (isNew == 0) {
                wx.miniProgram.navigateTo({
                    url: `/pages/case/case_olddetail_vue/index?topicid=${id}&userid=${this.$route.query.userid}`,
                });
            } else if (isNew == 1) {
                wx.miniProgram.navigateTo({
                    url: `/pages/case/case_detail_vue/index?topicid=${id}&userid=${this.$route.query.userid}`,
                });
            }
            // wx.miniProgram.navigateTo({ url: `/pages/case/case_detail_vue/index?topicid=${id}&userid=${this.$route.query.userid}` });
        },

        goTop() {
            this.sMove = 'top'
        },
        goBottom() {
            this.sMove = 'bottom'
        }
    }


}
</script>

<style lang="scss" scoped>
    // @import './index.scss'
    .case-list{
        width: 100%;
        height: 540px;
        position: fixed;
        bottom: 0px;
        left: 0;
        z-index: 999;
        background-color: #fff;
        overflow: hidden;
        .close{
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width: 60px;
                height: 13px;
            }
            .top{
                transform:rotate(180deg);
            }
        }
        .list{
            padding: 0px 30px;
            li{
                padding: 30px 0px;
                display: flex;
                border-bottom: 1px solid rgb(193, 193, 193);

                &>img{
                    width: 159px;
                    height: 159px;
                    flex-shrink: 0;
                    object-fit: cover;
                }
                .list-right{
                    margin-left: 30px;
                    .title{
                        font-size: 32px;
                        color: rgb(38, 49, 103);
                        font-weight: bold;
                    }
                    .info{
                        margin-top: 10px;
                        font-size: 24px;
                        color: rgb(0, 0, 0);
                        font-weight: bold;
                    }
                    .shop-list{
                        margin-top: 15px;
                        .shop{
                            font-size: 24px;
                            color: rgb(0, 0, 0);
                            display: inline-block;
                            margin-bottom: 10px;
                            &:last-child{
                                margin-bottom: 0;
                            }
                            &::before {
                                content: "";
                                display: inline-block;
                                margin-right: 15px;
                                margin-left: 10px;
                                width: 13px;
                                height: 13px;
                                background: url("~@/assets/images/case/dian_icon.png") no-repeat center/100% 100%;
                                flex-shrink: 0;
                            }
                        }
                    }
                }
            }
            li:last-child{
                margin-bottom: 50px;
                border-bottom: 0;
            }
        }
    }
    .show-all{
        animation: moveTop .3s linear forwards;
    }
    .show-half{
        animation: moveBottom .3s linear forwards;
    }
    .no-data{
        text-align: center;
        margin-top: 30px;
    }
    @keyframes moveTop {
        0% {
            height: 540px;
        }

        100% {
            height: 70%;
        }
    }
    @keyframes moveBottom {
        0% {
            height: 70%;
        }

        100% {
            height: 60px;
        }
    }
</style>
